import React, { useEffect } from 'react'
import Header2 from '../layout/Header2'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import MainBannerPackages from '../components/packages/MainBannerPackages'
import Packages from '../components/packages/Packages'
import { useLanguage } from '../contexts/LanguageContext'

const PackagesPage = () => {
    const { t } = useLanguage();

    useEffect(() => {
        window.scrollTo(0, 0)
    },[])
      return (
    <>
    <HelmetProvider>
    <Helmet prioritizeSeoTags>
        <title>{t('seo.packagesTitle')}</title>
        <meta name="description" content={t('seo.packagesDescription')} />
    </Helmet>
    </HelmetProvider>
    <Header2/>

    <div style={{ overflow: 'hidden', backgroundImage:'url("/bg-img/MicrosoftTeams-image.webp")', width:'100%', backgroundAttachment:'fixed' }}>

        <MainBannerPackages/>
        <Packages/>
    </div>
    </>
  )
}

export default PackagesPage